import React, { useEffect, useState } from 'react'
import { useSelector, shallowEqual } from 'react-redux'

import MessageViewUI from './MessageViewUI'

const MessageView = ({ renderType, label, placeholder, actionType, dataWay, currentValue, onChange, editorOptions, isNote, error }) => {
  const { company, modalActionRef } = useSelector(store => ({
    company: store.companies,
    modalActionRef: dataWay?.type === 'alternatives'
      ? store.smartchatAlternatives.alternativesModalActionRef.find(modalActionRef => modalActionRef.alternativesId === dataWay.alternativesId) || {}
      : store.smartchatDetails.modalActionRef
  }), shallowEqual)
  const [value, setValue] = useState({})

  // Current data
  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      if (!currentValue || !Object.keys(currentValue).length) return

      if (modalActionRef.mode === 'update' || renderType === 'preview') {
        if (actionType === 'emitBotMessage') {
          setValue(currentValue)
        } else {
          setValue({
            content: currentValue.messageText,
            contentHtml: '',
            buttons: [],
            attachments: []
          })
        }
      }
    }

    return () => isSubscribed = false
  }, [currentValue])

  // Export the data
  const onChangeInner = (messageData) => {
    if (modalActionRef.mode === 'add') setValue(messageData)
    if (actionType === 'emitBotMessage') {
      onChange(messageData)
    } else {
      onChange({ messageText: messageData.content })
    }
  }

  if (Object.keys(currentValue).length && !Object.keys(value).length) return null

  return (
    <MessageViewUI
      renderType={renderType}
      company={company}
      label={label}
      placeholder={placeholder}
      value={value}
      editorOptions={editorOptions}
      onChangeInner={onChangeInner}
      isNote={isNote}
      error={error}
    />
  )
}

export default MessageView
